import { mergeDeep } from '@sitecore-search/common';
import { DataProvider } from '@sitecore-search/data';
import Actions from '../actions.js';
import PageController from '../controller/page.js';
import Dispatcher from '../dispatcher.js';
import { cancelablePromise } from './helpers.js';
const createRequestId = () => String(Date.now().toString(32) + Math.random().toString(16)).replace(/\./g, '');
export default {
    async getData(request, options) {
        const abortController = new AbortController();
        const newOptions = { ...options, signal: abortController.signal, abortController };
        return cancelablePromise(this.fetch(request.toJson(), newOptions), abortController);
    },
    async fetch(request, options) {
        const requestId = createRequestId();
        const pageContext = PageController.getContext();
        const payload = mergeDeep({ context: pageContext.toJson() }, request);
        Dispatcher.dispatch({
            type: Actions.REQUEST,
            payload: { requestId, request, pageContext, payload },
        });
        try {
            const response = await DataProvider.get(payload, { signal: options?.signal });
            Dispatcher.dispatch({
                type: Actions.REQUEST_SUCCESS,
                payload: { requestId, request, pageContext, payload, response },
            });
            return { _requestId: requestId, ...response };
        }
        catch (error) {
            Dispatcher.dispatch({
                type: Actions.REQUEST_FAIL,
                payload: { error, requestId, request, pageContext, payload },
            });
            return Promise.reject(error);
        }
    },
};
